import axios from 'axios'



export default class PackageService {



    async getPackages(token) {

        const res = await axios({
            method: 'get',
            url: process.env.VUE_APP_AUTH_URL + 'api/v1/packages',
            headers: {
                authorization: token
            }
        });

        return res.data;
    }




     
}


